import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/directions`;

export const getAll = async ({page = '', limit = '', mailClient = '', codCiudad = '', codDepartamento = ''}) => {
 const {data} = await axios.get(`${baseUrl}/?page=${page}&limit=${limit}&mailClient=${mailClient}&codCiudad=${codCiudad}&codDepartamento=${codDepartamento}`, config) 
 return data
}

export const create = async ({direccion = {}}) => {
 const {data} = await axios.post(baseUrl, direccion, config)
 return data
}

export const update = async ({direccion = {}, id}) => {
 const {data} = await axios.put(`${baseUrl}/${id}`, direccion, config)
 return data
}

export const del = async ({id}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}`, config)
 return data
}

export const getVinculedDirectionsWithClient = async ({mail = "undefined"}) => {
    if(!mail || mail === "undefined"){
        mail = "undefined"
    }
    const {data} = await axios.get(`${baseUrl}/findVinculedDirections/${mail}`, config)
    return data
}

export const desvinculedDirection = async ({idDireccion, idCliente}) => {
    const {data} = await axios.get(`${baseUrl}/desvinculedDirection/${idDireccion}/${idCliente}`, config) 
    return data
}

export const vinculedDirection = async ({idDireccion, idCliente}) => {
    const {data} = await axios.get(`${baseUrl}/vinculedDirection/${idDireccion}/${idCliente}`, config) 
    return data
}